import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toArray'
})
export class ToArrPipe implements PipeTransform {

  transform(value: string, args?: number): any {
    if(value){
      return  value.split(",");
    }
    return [];
  }

}



// WEBPACK FOOTER //
// ./src/pipes/toArray/toArray.pipe.ts